import { render, staticRenderFns } from "./KnFormAnnouncement.vue?vue&type=template&id=d1897df4"
import script from "./KnFormAnnouncement.js?vue&type=script&lang=js&external"
export * from "./KnFormAnnouncement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports